import { Check, Clock, Wifi, MapPin } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PACKAGES, SERVICES_MENU, waLink } from "../data/site";

export const Pricing = ({ onBook }) => {
    return (
        <section id="pricing" data-testid="pricing-section" className="py-28 lg:py-36 px-6 bg-[#0B1730] border-y border-white/5">
            <div className="max-w-7xl mx-auto">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <Overline>Packages & Pricing</Overline>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F0EBE0]">
                        Invest in <span className="italic text-[#C9A962]">knowing yourself</span>
                    </h2>
                    <p className="mt-4 text-sm font-light text-[#A19D94] flex items-center justify-center gap-4 flex-wrap">
                        <span className="flex items-center gap-1.5"><Clock size={14} className="text-[#C9A962]" /> ~2 hr sessions</span>
                        <span className="flex items-center gap-1.5"><Wifi size={14} className="text-[#C9A962]" /> Online</span>
                        <span className="flex items-center gap-1.5"><MapPin size={14} className="text-[#C9A962]" /> In-Person, Mulund West</span>
                    </p>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
                    {PACKAGES.map((p, i) => (
                        <Reveal key={p.name} delay={i * 0.12} className="h-full">
                            <div
                                data-testid={`package-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`relative rounded-2xl p-8 h-full flex flex-col transition-all duration-500 hover:-translate-y-1 ${
                                    p.featured
                                        ? "border border-[#C9A962]/50 bg-gradient-to-b from-[#12223F] to-[#0E1B33] shadow-[0_0_60px_rgba(201,169,98,0.15)] md:-translate-y-3"
                                        : "border border-white/10 bg-[#0E1B33] hover:border-[#C9A962]/30"
                                }`}
                            >
                                {p.featured && (
                                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-[#C9A962] text-[#081226] text-[10px] font-bold uppercase tracking-[0.2em]">
                                        Most Loved
                                    </span>
                                )}
                                <h3 className="font-display text-2xl font-semibold text-[#F0EBE0]">{p.name}</h3>
                                <p className="mt-3 text-sm font-light text-[#A19D94] leading-relaxed flex-none">{p.desc}</p>
                                <div className="mt-6 flex items-baseline gap-3">
                                    <span className="font-mono-num text-4xl font-light text-[#C9A962]">{p.price}</span>
                                    <span className="text-xs text-[#5C5A56] uppercase tracking-wider">{p.onlinePrice}</span>
                                </div>
                                <ul className="mt-6 space-y-2.5 flex-1">
                                    {p.features.map((f) => (
                                        <li key={f} className="flex items-start gap-2.5 text-sm text-[#A19D94]">
                                            <Check size={15} className="text-[#C9A962] mt-0.5 shrink-0" /> {f}
                                        </li>
                                    ))}
                                </ul>
                                <button
                                    data-testid={`package-book-${i}`}
                                    onClick={onBook}
                                    className={`mt-8 w-full py-3.5 rounded-full text-sm font-semibold uppercase tracking-[0.15em] transition-all ${
                                        p.featured
                                            ? "bg-[#C9A962] text-[#081226] hover:bg-[#dcc083] hover:shadow-[0_0_30px_rgba(201,169,98,0.45)]"
                                            : "border border-[#C9A962]/40 text-[#C9A962] hover:bg-[#C9A962]/10"
                                    }`}
                                >
                                    Book Now
                                </button>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <div className="mt-16 rounded-2xl border border-white/10 bg-[#0E1B33] overflow-hidden">
                        <div className="px-8 py-5 border-b border-white/5">
                            <h3 className="font-display text-xl font-semibold text-[#F0EBE0]">Full Service Menu</h3>
                            <p className="text-xs text-[#5C5A56] mt-1">All sessions include detailed analysis, written report & remedies.</p>
                        </div>
                        <div className="divide-y divide-white/5">
                            {SERVICES_MENU.map((s, i) => (
                                <div key={s.name} data-testid={`menu-item-${i}`} className="px-8 py-4 flex items-center justify-between gap-4 hover:bg-white/[0.02] transition-colors">
                                    <span className="text-sm text-[#F0EBE0]">{s.name}</span>
                                    <a
                                        data-testid={`menu-dm-${i}`}
                                        href={waLink(`Hi Maitrii! I'd like to know more about ${s.name}.`)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="px-5 py-2 rounded-full border border-[#C9A962]/40 text-[#C9A962] text-[10px] font-semibold uppercase tracking-[0.2em] hover:bg-[#C9A962] hover:text-[#081226] transition-all whitespace-nowrap"
                                    >
                                        DM to Know More
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
